import { Component, OnInit } from '@angular/core';
import { MachinesSeries, MachinesSerie } from 'src/app/model/series/machinesSeries';
import { SeriesService } from 'src/app/services/http/series/series.service';



@Component({
  selector: 'app-series-list',
  templateUrl: './series-list.component.html',
  styleUrls: ['./series-list.component.scss']
})
export class SeriesListComponent implements OnInit {

  constructor(private service: SeriesService) { }

  public machinesSeries !: MachinesSeries;

  public machines !: MachinesSerie;

  public btnClicked: boolean = false;


  ngOnInit(): void {

    this.service.getSeriesData().subscribe((machinesSeries) => {
      console.log(machinesSeries);
      this.machinesSeries = machinesSeries;
    });
    
  }

  /**
   * Get details of one machine serie. 
   */
  public getOneMachineSerieData( id : number ) {


      this.service.getMachinesSerieData( id.toString() ).subscribe((machines) => {

        console.log (machines);
        this.machines = machines;
        this.btnClicked = true;
      });

  }

  

}
